import { Component, EventEmitter, Input, Output } from '@angular/core';

type BtnsTypes =
  'primary' |
  'secondary' |
  'warning' |
  'secondary-bold' |
  'form' // botao branco com borda preta, usado muito no meio de formulários

@Component({
  selector: 'app-button',
  templateUrl: './button.component.html',
  styleUrls: ['./button.component.scss']
})
export class ButtonComponent {

  @Input() type: BtnsTypes = 'primary';
  @Input() text: string = '';
  @Input() disabled: boolean | null = false;

  @Output() buttonEvent = new EventEmitter();

  saveClickEvent() {
    if (! this.disabled) {
      this.buttonEvent.emit()
    }
  }

}
